import { Component } from '@angular/core';

@Component({
    selector: 'pf-healthfund',
    templateUrl: './healthfund.component.html',
    styleUrls: ['./healthfund.component.scss'],
    standalone: true
})
export class HealthfundComponent { }
